/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ActivityFeed from './ActivityFeed.tsx';

const queryClient = new QueryClient();

function ActivityFeedIndex(props) {
  return (
    <QueryClientProvider client={queryClient}>
      <ActivityFeed {...props} />
    </QueryClientProvider>
  );
}

ActivityFeedIndex.propTypes = {
  buildingId: PropTypes.number.isRequired,
  inspectionId: PropTypes.number,
  workOrderId: PropTypes.number,
  deficiencyId: PropTypes.number,
  proposalId: PropTypes.number,
  notesEnabled: PropTypes.bool
};

ActivityFeedIndex.defaultProps = {
  inspectionId: undefined,
  workOrderId: undefined,
  deficiencyId: undefined,
  proposalId: undefined,
  notesEnabled: true
};

export default ActivityFeedIndex;
